import React, { useEffect } from "react";
import { Button, Card, Select, Table } from "antd";
import PropTypes from "prop-types";
import { sanitizeFieldName } from "../../util/methods";
import AccessControl from "../AccessControl";

const { Option } = Select;

const getColumns = (columns) => {
  const customColumn = [];
  customColumn.push(<Option key={'assetCode'}
    value='assetCode'>Asset Code</Option>);
  customColumn.push(<Option key={'assetSubType'}
    value='assetSubType'>Asset Sub Type</Option>);
  customColumn.push(<Option key={'assetType'}
    value='assetType'>Asset Type</Option>);
  customColumn.push(<Option key={'location'}
    value='location'>Location</Option>);
  customColumn.push(<Option key={'client'}
    value='client'>Sub Location</Option>);
  customColumn.push(<Option key={'complaintDate'}
    value='complaintDate'>Complaint Date</Option>);
  customColumn.push(<Option key={'presentStatus'}
    value='presentStatus'>Present Status</Option>);
  customColumn.push(<Option key={'presentStatusRemark'}
    value='presentStatusRemark'>Present Status Remark</Option>);
  customColumn.push(<Option key={'activitiesAmount'}
    value='activitiesAmount'>Activities Amount</Option>);
  customColumn.push(<Option key={'sparesAmount'}
    value='sparesAmount'>Spares Amount</Option>);
  customColumn.push(<Option key={'totalAmount'}
    value='totalAmount'>Total Amount</Option>);
  customColumn.push(<Option key={'lastStatusReviewed'}
    value='lastStatusReviewed'>Last Status Reviewed</Option>);
  customColumn.push(<Option key={'lastStatusUpdate'}
    value='lastStatusUpdate'>Last Status Update</Option>);
  customColumn.push(<Option key={'owner'}
    value='owner'>Owner</Option>);
  customColumn.push(<Option key={'detailsOfComplaint'}
    value='detailsOfComplaint'>Details Of Complaint</Option>);
  customColumn.push(<Option key={'causeOfDamage'}
    value='causeOfDamage'>Cause Of Damage</Option>);

  const filterColumn = Object.keys(columns).map(item => {
    if (columns[item].options && columns[item].options.notVisible) {
      return null;
    }
    if (item === '_id' || item === 'password') {
      return null;
    }

    return <Option key={columns[item].field}
      value={columns[item].field}>{sanitizeFieldName(columns[item].field)}</Option>;
  });

  return [...customColumn, ...filterColumn];
};

const List = ({ title, columns, data, handleChange, columnChange, clearFilter, create, size, pagination,
  loading, filters, authUser, visibleColumn, seeReport, downloadToCSV, downloadProgress, fetchList }) => {
  useEffect(() => {
    // console.log('title:', title)
    if (title && title === 'JobCard') {
      fetchList();
    }
  }, []);

  return (
    <Card className={`gx-card-metrics`}>
      <div className=''>
        <div className='action-bar'>
          <AccessControl resource={title} permissionNeeded={'c'}
            roles={authUser ? authUser.roles : []} render={(props) => {
              return (title !== 'Asset' && title !== 'Activity' && title !== 'Log') ?
                <Button type='primary' onClick={create} icon='add'> Add New {sanitizeFieldName(title)}</Button> : <></>
            }} />

          <div className='action-bar'>

            <AccessControl resource={title} permissionNeeded={'r'}
              roles={authUser ? authUser.roles : []} render={(props) => {
                return <Button style={{ marginRight: '10px' }} disabled={columns.length <= 1 || downloadProgress > 0}
                  onClick={downloadToCSV}>Download to CSV</Button>;
              }} />

            {
              <AccessControl resource={title} permissionNeeded={'r'}
                roles={authUser ? authUser.roles : []} render={(props) => {
                  return (visibleColumn && visibleColumn.length ?
                    (<Select mode="multiple" maxTagCount={1} key={'1'}
                      style={{ width: '200px', marginRight: '10px' }}
                      placeholder="Visible Columns"
                      defaultValue={visibleColumn}
                      onChange={columnChange}>
                      {getColumns(filters)}
                    </Select>)
                    : (<Select mode="multiple" maxTagCount={1} key={'2'}
                      style={{ width: '200px', marginRight: '10px' }}
                      placeholder="Visible Columns"
                      defaultValue={visibleColumn}
                      onChange={columnChange}>
                      {getColumns(filters)}
                    </Select>))
                }} />
            }


            <Button onClick={clearFilter}>Clear filters and sorters</Button>
          </div>
        </div>
        <Table columns={columns} dataSource={data} scroll={{ x: 1400 }} onChange={handleChange} size={size} rowKey={'_id'}
          pagination={pagination} loading={loading} />
      </div>
    </Card>
  )
};

export default List;
List.defaultProps = {
  size: "middle"
};

List.propTypes = {
  title: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  columnChange: PropTypes.func.isRequired,
  clearFilter: PropTypes.func.isRequired,
  columns: PropTypes.array.isRequired,
  size: PropTypes.string,
  data: PropTypes.array.isRequired,
  create: PropTypes.func,
  pagination: PropTypes.object,
  loading: PropTypes.bool,
  filters: PropTypes.object,
  visibleColumn: PropTypes.array
};
